export const navLink = "robots_economics";
export const name = "Економика";
